import React from 'react'
import {t} from '../../i18n';
import {history} from '../../configureHistory'

export default () =>
{
  const state: any = history.location.state;
  window.history.replaceState(null, '', `/${state.data.LinkCode}`);
  return (
        <div>
            <div className="container text-center">
                <div className="row justify-content-md-center">
                    <div className="col-md-auto">
                        <h3>{t("OrderNotReadyForDelivery_TextUnderCommonText")}</h3>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-md-auto">
                        <h3>{t("OrderNotReadyForDelivery_TextAtTheBottom")}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
